const InventoryIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.849,7.681l-9-7.043a2.989,2.989,0,0,0-3.7,0l-9,7.042A2.985,2.985,0,0,0,0,10.043V24H24V10.043A2.981,2.981,0,0,0,22.849,7.681ZM18,22H6V13a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Zm4,0H20V13a3,3,0,0,0-3-3H7a3,3,0,0,0-3,3v9H2V10.043a.994.994,0,0,1,.384-.788l9-7.043a1,1,0,0,1,1.232,0l9,7.044a.991.991,0,0,1,.384.787ZM10,18h4v2H10Z" />
  </svg>
);

export default InventoryIcon;
